import { render, staticRenderFns } from "./VendorRegistration.vue?vue&type=template&id=7e460d43&scoped=true&"
import script from "./VendorRegistration.vue?vue&type=script&lang=js&"
export * from "./VendorRegistration.vue?vue&type=script&lang=js&"
import style0 from "./VendorRegistration.vue?vue&type=style&index=0&id=7e460d43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e460d43",
  null
  
)

export default component.exports